import { render } from "./ProjectWorkspaceView.vue?vue&type=template&id=72a95094&scoped=true&ts=true"
import script from "./ProjectWorkspaceView.vue?vue&type=script&lang=ts"
export * from "./ProjectWorkspaceView.vue?vue&type=script&lang=ts"

import "./ProjectWorkspaceView.vue?vue&type=style&index=0&id=72a95094&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a95094"]])

export default __exports__